import {charcoal} from '../sass/base/_exports.sass';

export const TextColorIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1, width = 20, height = 20} = props;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7631 13.3002H16.0491L11.2251 0.700195H8.77712L3.95312 13.3002H6.23913L7.30113 10.4202H12.7011L13.7631 13.3002ZM8.16512 8.0622C8.97512 5.8842 9.56913 4.1742 10.0011 2.5362C10.4331 4.1742 11.0451 5.8842 11.8371 8.0622L12.0171 8.5302H7.98513L8.16512 8.0622Z"
        fill="#101B21"
      />
      <rect y="15.3003" width="20" height="4" rx="2" fill={color} />
    </svg>
  );
};
